import { render } from "./LogoIcon.vue?vue&type=template&id=6cd9d5b8"
const script = {}
script.render = render

export default script